import * as React from 'react';
import CardSection from '../../common/CardSection';

class OwnershipPage extends React.Component<{}> {
    public render() {
        return <CardSection title="Ownership" />;
    }
}

export default OwnershipPage;



// WEBPACK FOOTER //
// ./src/components/project/sections/Ownership.tsx